<template>
    <div id="survey-request-template">
        <loader v-if="!survey || submitting" />
        <survey-template-workflow v-else
            v-model="responses"
            :survey="survey" 
            :interpolations="interpolations"
            @responded="responded"
            @submit="submit"
        />
    </div>
</template>

<script>
import SurveyClient from "@/api/SurveyClient.js";
import SurveyTemplateWorkflow from '../survey-template-workflow/SurveyTemplateWorkflow.vue'
import Loader from '@/components/Loader.vue';

export default {
    components: {
        SurveyTemplateWorkflow,
        Loader,
    },
 
    data() {
        return {
            client: new SurveyClient(this.$http),
            submitting: false,
            survey_request_id: null,
            survey: null,
            responses: null,
            interpolations: null
        }
    },
    async mounted() {
        const { id } = this.$route.query;
        if (!id)
            this.$router.push({ name: 'home' });

        try {
            const response = await this.client.getResponseForAnonymous(id)
            
            this.interpolations = response.interpolations || { }
            this.survey_response_id = response.external_id
            this.survey = response.survey
            this.responses = response.responses || { }
        } catch(ex) {
            console.error(ex)
            this.$router.push({ name: 'home' });
        }
    },
    methods: {
        async responded({question, answer, next, interupt}) {
            try 
            {
                const slug = question.slug

                if(question.multiple_choice)
                    await this.client.respondToMultipleChoiceQuestion(this.survey_response_id, slug, answer)
                else if (question.free_text)
                    await this.client.respondToFreeTextQuestion(this.survey_response_id, slug, answer)
                else if (question.star_rating)
                    await this.client.respondToStarRatingQuestion(this.survey_response_id, slug, answer)
                else
                    throw Error("Unknown question type")
                
                next();
            } 
            catch (ex)
            {
                this.emit_error(ex, 'Failed to save answer! Please try again.')
                interupt();
            }
        },
        async submit(responses) {
            try {
                this.submitting = true
                await this.client.submitSurvey(this.survey_response_id)
                this.$router.push({name: 'survey-thank-you'})
            } catch (ex) {
                this.emit_error(ex, 'Failed submitting! Please try again.')
            }
        },
        emit_error(ex, defaultMessage) { 
            console.error(ex)
            let errorMessage = defaultMessage;
            if (ex && ex.body && ex.body.error && ex.body.error.extra && ex.body.error.extra.detail) {
                errorMessage = ex.body.error.extra.detail;
            } else if (ex && ex.body && ex.body.error && ex.body.error.message) {
                errorMessage = ex.body.error.message;
            }

            this.$store.commit('setGlobalAlert', {
                msg: errorMessage, error: true,
            });
        }
    }
}
</script>
<style lang="scss" scoped>
</style>